import { render, staticRenderFns } from "./kdReasonAnalystAudit.vue?vue&type=template&id=1505f34c&scoped=true"
import script from "./kdReasonAnalystAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./kdReasonAnalystAudit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1505f34c",
  null
  
)

export default component.exports